<template>
    <form name="form-upload-presentation-file" id="form-upload-presentation-file" @submit="onSubmit">
        <div class="form-row">

            <div class="col-md-12">
                <div class="form-group">
                    <label for="speakerName">Speaker Name</label>
                    <InputText class="form-control" v-model="model.speakerName" id="speakerName" :readonly="true"></InputText>
                </div>

                <div class="form-group">
                    <label for="eventDetailName">Event Name</label>
                    <InputText class="form-control" v-model="model.eventDetailName" id="eventDetailName" :readonly="true"></InputText>
                    <input type="hidden" name="eventDetailId" v-model="model.eventDetailId">
                </div>

                <div class="form-group">
                    <label for="topic">Topic</label>
                    <Textarea class="form-control" v-model="model.topic" id="topic" rows="5"></Textarea>
                </div>

                <div class="form-group">
                    <label for="presentationFile">Presenation File</label>
                    <FileUpload mode="advanced" name="file" :multiple="false" accept="application/pdf"  v-model="model.uploadFile" :url="uploadUrl" @error="onUploadError" @upload="onUploadSuccess"></FileUpload>
                </div>
            </div>
        
        </div>

        <div class="d-flex justify-content-end mb-sm-1">
            <button type="button" class="btn btn-outline-secondary mr-sm-1" @click="onCancel">Cancel</button>
            <button type="submit" class="btn btn-primary" :disabled="saving">Submit</button>
        </div>

    </form>
</template>

<script>
import {defineComponent} from 'vue'
import InputText from "primevue/inputtext";
import FileUpload from "primevue/fileupload";
import apiService from "@/services/ApiService";
import Textarea from 'primevue/textarea';


export default defineComponent({
    name: "PresentationFileUploadForm",
    components: {
        InputText, FileUpload, Textarea
    },
    props: {
        speaker: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            model: {
                id: '',
                speakerName: '',
                eventDetailId: '',
                eventDetailName: '',
                topic: '',
                uploadFile: '',
                fileName: '',
                fileNameOrigin: '',
            },
            saving: false,
            uploadUrl: ''
        }
    },

    methods: {
        onSubmit(event) {
            event.preventDefault();
            this.saving = true;
            
            let url = '/eventdetail/upload-presentation-file';
            let successMessage = 'Presentation file has been uploaded';
            let errorMessage = 'Failed to upload presentation file';

            apiService.post(url, this.model)
                .then(() => {

                    this.$emit('onSubmitUploadPresentationFile');


                    this.$toast.add({
                        severity: 'success',
                        summary: 'Success',
                        detail: successMessage,
                        life: 5000
                    });
                })
                .catch(error => {
                    console.log(error);
                    this.$toast.add({
                        severity: 'error',
                        summary: errorMessage,
                        detail: error.response.data.Message,
                        life: 5000
                    });
                })
                .finally(() => {
                    console.log('final');
                    this.saving = false;
                });
        },
        onCancel() {
            this.$emit('onCancelUploadPresentationFile');
        },
        onUploadSuccess(event){
            let response = JSON.parse(event.xhr.response);
            console.log(event.xhr.response);
            this.model.fileName = response.fileName;
            this.model.fileNameOrigin = response.fileNameOrigin;
        },
        onUploadError(event){
            let response = JSON.parse(event.xhr.response);
            this.$toast.add({
                severity: 'error',
                summary: 'Failed to upload file',
                detail: response.Message,
                life: 5000
            });
        },
    },
    mounted() {
        this.uploadUrl = `${apiService.defaults.baseURL}/file/upload`;
        this.model.id = this.speaker.eventDetailSpeakerId;
        this.model.speakerName = this.speaker.name;
        this.model.eventDetailId = this.speaker.eventDetailId;
        this.model.eventDetailName = this.speaker.eventDetailName;
        this.model.topic = this.speaker.topic;
    }
})
</script>


<style scoped>

</style>
